export default __webpack_public_path__ + "cc82fd80f55717719434c845e7d2ba9e.jpg";